import React from 'react';
import { FastField } from 'formik';
import UploadImage from '../UploadImages';

const UploadImageField = props => (
  <FastField name={props.name}>
    {({ field, form }) => (
      <div className="form-group">
        <UploadImage
          title={props.label}
          limit={props.limit || 0}
          images={form.values[field.name]}
          touched={(form.touched[field.name] === true)}
          error={form.errors[field.name] || props.error}
          onTouched={() => { form.setFieldTouched(field.name, true); }}
          onChange={(files) => { form.setFieldValue(field.name, files); }}
        />
      </div>
    )}
  </FastField>
);

export default UploadImageField;



// WEBPACK FOOTER //
// ./src/components/UploadImageField/index.js